<template>
  <header>
    <nav class="navbar fixed-top bg-light shadow-lg h-60 d-md-none to-front">
      <div class="container-fluid d-flex justify-content-between align-items-center">
        <div>
          <ToggleButton />
        </div>
        <div>
          <router-link to="/" class="text-decoration-none fs-5 py-1">
            <img class="me-1 align-text-bottom" src="/logo.png" width="90">
          </router-link>
        </div>
        <AvatarMenu class="link-primary" />
      </div>
    </nav>
  </header>
</template>

<script>
import ToggleButton from '../components/ToggleSidebarButton.vue';
import AvatarMenu from '../components/AvatarMenu.vue';

export default {
  components: { AvatarMenu, ToggleButton },
};
</script>

<style scoped>
  .h-60 { height: 60px; }
  .to-front { z-index: 1100!important; }
  .navbar.fixed-top { min-width: 320px; }
</style>
